import { useContext } from 'react';
import { RescheduleRequestViewContext } from './context';

export const useRescheduleRequestView = () => {
  const context = useContext(RescheduleRequestViewContext);

  if (!context) throw new Error('useRescheduleRequestView must be used within a RescheduleRequestViewProvider');

  return context;
};
